import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";
import _cookies from "../../../shared/utils/_cookies";

export async function moderatePost({ postId, action, reason }) {
  const body = new FormData();
  body.append(
    "dados",
    `[${JSON.stringify({
      postagemid: postId,
      analise: action,
      motivo: reason,
      gestorid: _cookies.getItem("auth").user?.profile?.isGestor?.ID,
    })}]`
  );
  const res = await axios.middleware.post(
    "/Social.asmx/Analise_Postagem",
    body
  );
  return res;
}

export const useModeratePost = ({ config, postId } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: moderatePost,

    onSuccess: () => {
      queryClient.invalidateQueries(["socialMediaFeed"]);
    },
  });
};
